import { IAuthState, IResponse } from 'src/interface';
import { getWithPath, postWithPath } from 'src/utils/http';

const API_PATH = {
    GET_PROFILE: '/user/get/profile',
    LOGOUT: '/auth/post/logout',
    LOGIN_BY_ZALO: '/auth/post/login',
};

export const AuthService = {
    auth: (): Promise<IResponse<IAuthState>> => {
        return getWithPath(API_PATH.GET_PROFILE);
    },
    logout: (): Promise<IResponse<IAuthState>> => {
        return postWithPath(API_PATH.LOGOUT);
    },
    loginByZalo: (
        oauthCode: string,
        codeVerifier: string,
        accessToken?: string
    ): Promise<IResponse<IAuthState>> => {
        return postWithPath(
            API_PATH.LOGIN_BY_ZALO,
            {},
            { oauthCode, codeVerifier, accessToken }
        );
    },
};

export default AuthService;
